export const success='success'
export const info='info'
export const warning='warn'
export const danger='error'